<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  reportsMethods,
  reportsComputed,
  exportMethods,
  erpFixMessages,
  kantoAdsMethods,
  kantoAdsComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";
// import moment from 'moment';
import { getModuleAccess } from "@/router/helper.js";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Kanto Ads Topup Details",
  },
  data() {
    return {
      sortingValue: {
        sort: "id",
        orderDesc: true,
      },
      logsModalfields: [
        {
          key: "modified_by",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "remarks",
          sortable: true,
        },
        {
          key: "modified_at",
          label: "Modified Date & Time",
          sortable: true,
        },
      ],

      search: {
        dateRange: null,
        sort: "id",
        orderDesc: true,
      },
      isRange: null,
      rangeOptions: {
        mode: "range",
      },
      topup: {},
      prevTopupValue: {},
      statusOptions: [
        { text: "Confirmed", value: "confirmed" },
        { text: "On Hold", value: "on hold" },
        { text: "Pending", value: "pending" },
        { text: "Declined", value: "declined" },
      ],
      isVisible: false,
      imgsRef: [],
      indexRef: 0,
      showTopupLogsModal: false,
      topupChangeLogs: [],
      logsCurrentPage: 1,
      logsPerPage: 10,
      logsPageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      logsSortBy: "",
      logsSortDesc: true,
      logsSortOrder: "DESC",
      logsDateRange: null,
      isSearching: false,
      topupModule: {
        access: {
          update: true,
        },
      },
      onHoldOptions: [
        { text: "Unreadable payment receipt", value: "unreadable payment receipt" },
        { text: "Transaction reference number provided is incorrect", value: "transaction reference number provided is incorrect" },
        { text: "Discrepancy in the received amount", value: "discrepancy in the received amount" },
      ],
      declinedOptions: [
        { text: "It raised some security concerns", value: "it raised some security concerns" },
        { text: "The bank was unable to verify your transaction", value: "the bank was unable to verify your transaction" },
        { text: "We found out that the transaction details you provided is fraudulent", value: "we found out that the transaction details you provided is fraudulent" },
      ],
      submitted: false,
      onHoldRemarks: [],
      declinedRemarks: [],
    };
  },
  validations: {
    onHoldRemarks: { required },
    declinedRemarks: { required },
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...kantoAdsComputed,
    setStatusOptions: {
      get() {
        if (this.prevTopupValue.status == "on hold") {
          return this.statusOptions.map(status => {
            if (status.value == 'pending') {
                status.disabled = true;
            }
            return status;
          })
        } else if (this.prevTopupValue.status == "confirmed" || this.prevTopupValue.status == "declined") {
          return this.statusOptions.map(status => {
            status.disabled = true;

            return status;
          })
        } else {
          return this.statusOptions
        }
      },
    },
  },
  async mounted() {
    this.changeTitle({ title: "Top-up Bank Transfer" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Kanto Ads", to: { name: "" } },
        { text: "Topup Transactions", to: { name: "Topup Transaction" } },
      ],
    });

    if (this.$route.params.id != undefined) {
      await this.getMcpTopup({ topupId: this.$route.params.id }).then(() => {
        this.topup = JSON.parse(JSON.stringify(this.mcpTopup));
        this.prevTopupValue = JSON.parse(JSON.stringify(this.mcpTopup));
        this.topup.remarks = this.topup.remarks != 'null' ? this.topup.remarks : '';
        this.prevTopupValue.remarks = this.topup.remarks != 'null' ? this.topup.remarks : '';
        this.imgsRef[0] = this.topup.proof_photo;
        if (this.topup.status == 'on hold') {
          this.onHoldOptions.forEach(item => {
            this.topup.remarks.forEach(remark => {
              if (item.value == remark.value) {
                this.onHoldRemarks.push(item)
              }
            })
          })
        } else if (this.topup.status == 'declined') {
          this.declinedOptions.forEach(item => {
            this.topup.remarks.forEach(remark => {
              if (item.value == remark.value) {
                this.declinedRemarks.push(item)
              }
            })
          })
        }
      });
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("Products", "Kanto Ads", "Top-up Bank Transfer").then(
      (access) => (this.topupModule.access = access)
    );
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...kantoAdsMethods,
    async updateTopup() {
      this.submitted = true;
      this.$v.$touch();

      if ((this.topup.status == 'on hold' && this.$v.onHoldRemarks.$invalid) || (this.topup.status == 'declined' && this.$v.declinedRemarks.$invalid)) {
        return;
      }

      if (this.topup.status == 'on hold') {
        this.topup.remarks = this.onHoldRemarks.map(r => {
          return {
            value: r.value
          }
        });
        this.topup.remarks = JSON.stringify(this.topup.remarks);
      } else if (this.topup.status == 'declined') {
        this.topup.remarks = this.declinedRemarks.map(r => {
          return {
            value: r.value
          }
        });
        this.topup.remarks = JSON.stringify(this.topup.remarks);
      }

      if (
        this.topup.status != this.prevTopupValue.status ||
        this.topup.remarks != this.prevTopupValue.remarks
      ) {
        let params = {
          id: this.$route.params.id,
          status: this.topup.status,
          remarks:
            this.topup.remarks != null || this.topup.remarks != ""
              ? this.topup.remarks
              : null,
          updatedBy: JSON.parse(localStorage.getItem("userData")).email,
        };

        await this.updateMcpTopup(params).then(() => {
          Swal.fire(
            "Update Successful!",
            `${this.topup.organization_name} has been updated.`,
            "success"
          ).then(() => {
            this.$router.back();
          });
        });
      } else {
        Swal.fire(
          "Update Successful!",
          `${this.topup.organization_name} has been updated.`,
          "success"
        ).then(() => {
          this.$router.back();
        });
      }
    },
    async getChangeLogs() {
      this.logsCurrentPage = this.isSearching ? 1 : this.logsCurrentPage;

      let params = {
        topupId: this.$route.params.id,
        dateRange: this.logsDateRange,
        page: this.isSearching ? 1 : this.logsCurrentPage,
        limit: this.isSearching ? 10 : this.logsPerPage,
        sortBy: this.isSearching ? "" : this.logsSortBy,
        sortOrder: this.isSearching ? "DESC" : this.logsOrderDesc,
      };

      this.getTopupChangeLogs(params).then(() => {
        this.topupChangeLogs = JSON.parse(
          JSON.stringify(this.mcpTopupChangeLogs)
        );
        this.isSearching = false;
      });
    },
    async showReasonLogsModal() {
      this.getChangeLogs().then(() => {
        this.showTopupLogsModal = true;
      });
    },
    closeLogsModal() {
      this.showTopupLogsModal = false;
      this.logsDateRange = null;
      this.logsCurrentPage = 1;
      this.logsPerPage = 10;
      this.logsSortBy = "";
      this.logsSortDesc = true;
      this.logsSortOrder = "DESC";
    },
    async tableSorting(action) {
      var column = "";
      switch (action.sortBy) {
        case "modified_by":
          column = "modified_by";
          break;
        case "status":
          column = "status";
          break;
        case "remarks":
          column = "remarks";
          break;
        case "modified_at":
          column = "modified_at";
          break;
      }

      this.logsSortBy = column;
      this.logsSortOrder = action.sortDesc ? "DESC" : "ASC";
      await this.getChangeLogs();
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <label
              v-if="!topupModule.access.update"
              class="form-label medium fw-bold text-danger mb-2"
              style="padding-bottom: 10px"
            >
              Note: Your access is limited. You cannot update a Topup.
            </label>
            <div class="border-bottom-gray">
              <label>Top-up Bank Transfer Details</label>
            </div>
            <b-row class="mt-4">
              <b-col>
                <label>Request Reference Number:</label>
              </b-col>
              <b-col class="ta-right">
                <p>{{ topup.supp_ref_no }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Brand Owner:</label>
              </b-col>
              <b-col class="ta-right">
                <p>{{ topup.organization_name }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Transaction Date & Time:</label>
              </b-col>
              <b-col class="ta-right">
                <p>{{ topup.created_at | formatDate }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Chosen Bank:</label>
              </b-col>
              <b-col class="ta-right">
                <p>{{ topup.bank_name }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Top-up Amount:</label>
              </b-col>
              <b-col class="ta-right">
                <p>₱{{ topup.amount }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Bank Reference Number:</label>
              </b-col>
              <b-col class="ta-right">
                <p>{{ topup.reference_no }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2 align-items-center">
              <b-col>
                <label>Proof of Payment:</label>
              </b-col>
              <b-col class="ta-right">
                <b-button
                  variant="outline-light"
                  class="p-0"
                  @click="isVisible = true"
                >
                  <b-img
                    :src="topup.proof_photo"
                    @error="
                      (e) =>
                        (e.target.src = require('@/assets/images/img-placeholder.png'))
                    "
                    thumbnail
                    height="70"
                    width="100"
                  ></b-img>
                </b-button>
              </b-col>
              <vue-easy-lightbox
                :visible="isVisible"
                :imgs="imgsRef"
                @hide="isVisible = false"
              ></vue-easy-lightbox>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <label>Status:</label>
              </b-col>
              <b-col class="ta-right">
                <b-form-select
                  style="width: 10rem !important"
                  :options="setStatusOptions"
                  class="form-select rounded-0 rounded-start rounded-end shadow-none ms-auto"
                  v-model="topup.status"
                  size="sm"
                  :class="{
                    'pending-color-code': topup.status == 'pending',
                    'on-hold-color-code': topup.status == 'on hold',
                    'confirmed-color-code': topup.status == 'confirmed',
                    'declined-color-code': topup.status == 'declined',
                    'disabled-confirmed': prevTopupValue.status == 'confirmed',
                    'disabled-declined': prevTopupValue.status == 'declined',
                  }"
                  :disabled="prevTopupValue.status == 'confirmed' || prevTopupValue.status == 'declined'"
                  @change="topup.remarks = ''; submitted = false; onHoldRemarks = ''; declinedRemarks = ''"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <label>Remarks:</label>
              <div>
                <multiselect
                  v-if="topup.status == 'on hold'"
                  :multiple="true"
                  v-model="onHoldRemarks"
                  :options="onHoldOptions"
                  track-by="value"
                  label="text"
                  name="topupRemarks"
                  select-label="Click to select"
                  deselect-label="Click to remove"
                  placeholder="Select Reason"
                  :allow-empty="true"
                  :preselect-first="false"
                  :hide-selected="true"
                  :close-on-select="false"
                  :class="{ invalid: submitted && $v.onHoldRemarks.$error, }"
                ></multiselect>

                <multiselect
                  v-else-if="topup.status == 'declined'"
                  :multiple="true"
                  v-model="declinedRemarks"
                  :options="declinedOptions"
                  track-by="value"
                  label="text"
                  name="topupRemarks"
                  select-label="Click to select"
                  deselect-label="Click to remove"
                  placeholder="Select Reason"
                  :allow-empty="true"
                  :preselect-first="false"
                  :hide-selected="true"
                  :close-on-select="false"
                  @change="submitted = false;"
                  :class="{ invalid: submitted && $v.declinedRemarks.$error, }"
                ></multiselect>

                <div v-else-if="['confirmed','pending'].includes(topup.status)">
                  <b-form-textarea
                    id="textarea"
                    v-model="topup.remarks"
                    placeholder="Type remarks..."
                    rows="3"
                    max-rows="6"
                    maxlength="100"
                  ></b-form-textarea>
                  <div class="text-muted mt-1">
                    {{ topup.remarks != null ? topup.remarks.length : 0 }} / 100
                  </div>
                </div>

                <div v-if="topup.status == 'on hold' && (submitted && $v.onHoldRemarks.$error)" class="text-danger">
                  <span v-if="topup.status == 'on hold' && !$v.onHoldRemarks.required">Reason is required.</span>
                </div>

                <div v-if="(topup.status == 'declined') && (submitted && $v.declinedRemarks.$error)" class="text-danger">
                  <span v-if="topup.status == 'declined' && !$v.declinedRemarks.required">Reason is required.</span>
                </div>
              </div>
            </b-row>
            <div class="d-flex flex-row align-items-center mt-4">
              <div class="align-items-center">
                <label>Change Log: &nbsp;</label>
                <b-link @click="showReasonLogsModal">View</b-link>
              </div>
              <div class="ms-auto">
                <b-button
                  :disabled="!topupModule.access.update"
                  variant="primary me-2 custom-button-width"
                  @click="updateTopup"
                  >Update</b-button
                >
                <b-button
                  variant="light custom-button-width"
                  @click="$router.back()"
                  >Close</b-button
                >
              </div>
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- Topup Change Logs Modal -->
    <b-modal
      v-model="showTopupLogsModal"
      size="xl"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
      scrollable
    >
      <form class="px-4 py-3">
        <div class="row">
          <div class="col-lg-12">
            <!-- <div class="card">
            </div> -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <h5 class="card-title">Top-up Bank Transfer Log</h5>
                  </div>
                </div>

                <!-- Date Range -->
                <div class="col-md-12">
                  <div class="d-flex flex-wrap mt-3 mb-2 ta-right gap-2">
                    <div class="col-sm-3" style="width: fit-content">
                      <b-form-group description="Filter by date">
                        <flat-pickr
                          v-model="logsDateRange"
                          :config="rangeOptions"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: 250px"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button
                        variant="primary"
                        type="button"
                        @click="
                          isSearching = true;
                          getChangeLogs();
                        "
                        class="px-2 d-flex align-items-center"
                      >
                        <div><i class="bx bx-search bx-fw"></i></div>
                        <div>Search</div>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="topupChangeLogs"
                    :fields="logsModalfields"
                    responsive="sm"
                    :current-page="logsCurrentPage"
                    :sort-by.sync="logsSortBy"
                    :sort-desc.sync="logsSortDesc"
                    class="table-check"
                    @sort-changed="tableSorting"
                  >
                    <template #cell(modified_by)="data">
                      <p class="text-body m-0">{{ data.item.modified_by }}</p>
                    </template>

                    <template #cell(status)="data">
                      <p class="text-body m-0 text-capitalize">
                        {{ data.item.status }}
                      </p>
                    </template>

                    <template #cell(remarks)="data">
                      <div
                        class="text-body m-0"
                        v-b-tooltip.hover.bottom
                        :title="data.item.remarks"
                        v-if="data.item.remarks != null && data.item.remarks.length > 50"
                      >
                        <div class="text-truncate" style="width: 460px">
                          {{ data.item.remarks != null ? (data.item.remarks).charAt(0).toUpperCase() + data.item.remarks.slice(1) : '' }}
                        </div>
                      </div>
                      <p class="text-body m-0" v-else>
                        {{ data.item.remarks != null ? (data.item.remarks).charAt(0).toUpperCase() + data.item.remarks.slice(1) : '' }}
                      </p>
                    </template>

                    <template #cell(modified_at)="data">
                      <p class="text-body m-0">
                        {{ data.item.modified_at | formatDate }}
                      </p>
                    </template>
                  </b-table>
                </div>
              </div>
              <!-- end table responsive -->

              <div
                class="row g-0 text-center"
                v-if="mcpTopupChangeLogsTotal == 0"
              >
                <span>No data to display.</span>
              </div>
              <div
                class="row g-0 text-center text-sm-start"
                v-if="mcpTopupChangeLogsTotal > 10"
              >
                <!-- end col -->
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col">
                      <div class="form-group row pull-left">
                        <label for="staticEmail" class="col-sm-6 col-form-label"
                          >Display:</label
                        >
                        <div class="col-sm-6">
                          <b-form-group label-for="display-record">
                            <b-form-select
                              class="form-select shadow-none w-fit"
                              id="display-record"
                              v-model="logsPerPage"
                              :options="logsPageOptions"
                              @change="getChangeLogs()"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                        v-if="mcpTopupChangeLogsTotal > logsPerPage"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="logsCurrentPage"
                          :total-rows="mcpTopupChangeLogsTotal"
                          :per-page="logsPerPage"
                          @input="getChangeLogs()"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3 px-1">
          <b-button variant="light" class="w-sm" @click="closeLogsModal()"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
    <!-- End Topup Change Logs Modal -->
  </div>
</template>
<style>
.custom-checkbox-method label {
  margin-left: 10px;
}

.custom-checkbox-method input {
  margin-left: 15px;
}

.required-input {
  color: red;
}

.calendar-icon {
  display: block;
  font-size: 20px;
  padding: 8px;
  background-color: grey;
}

.border-bottom-gray {
  border-bottom: solid #ededed !important;
}

.custom-button-width {
  width: 6rem !important;
}

.pending-color-code {
  border-color: #831118 !important;
  color: #831118 !important;
}

.on-hold-color-code {
  border-color: #dc7512 !important;
  color: #dc7512 !important;
}

.confirmed-color-code {
  border-color: #e3e5e8 !important;
  color: #fff !important;
  background-color: #508f30 !important;
}

.declined-color-code {
  border-color: #868686 !important;
  color: #868686 !important;
}

.disabled-confirmed {
  border-color: #e3e5e8 !important;
  color: #fff !important;
  background-color: #508f30 !important;
  cursor: not-allowed;
}

.disabled-declined {
  border-color: #868686 !important;
  color: #868686 !important;
  cursor: not-allowed;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.invalid-remarks {
  border-color: #F34E4E !important;
}

</style>
